import {HTTP} from "@/helpers/http-common"
import * as R from "ramda";

const get = (entidades) =>new Promise((resolve,reject)=>{
  const {entidad} = entidades;
  HTTP.get(
    `/api/bitacora/${entidad}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const record = (entidades) =>new Promise((resolve,reject)=>{
  const {entidad, ruta} = entidades;
  HTTP
  .get(
    "/api/bitacora/record"
    , {
      params:{
        entidad:entidad
        , ruta:ruta
        , accion:'Acceso'
      }
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

//Export methods
export default {
  get
  , record
}




// WEBPACK FOOTER //
// ./src/services/bitacoras/bitacora/index.js